import request from './requestUtils'

interface FriendsAndFamilyReferralLink {
  fnfReferralLinkId: string
  fnfEmail: string
  fnfEmailPrefix: string
  referralLink: string
  verificationToken: string
  createdAt: string
  updatedAt: string
}

export type FriendsAndFamilyReferralStatus = 'PENDING' | 'ACCEPTED' | 'REVOKED'

export interface FriendsAndFamilyReferral {
  fnfReferralId: string
  fnfName: string
  fnfEmail: string
  referralName: string
  referralEmail: string
  status: FriendsAndFamilyReferralStatus
  approvedAt: string | null
  createdAt: string
  updatedAt: string
}

interface GetFriendsAndFamilyReferralsParams {
  fnfEmail?: string
  limit?: number
  offset?: number
}

interface CreateFriendsAndFamilyReferralLinkRequest {
  fnfEmail: string
}

interface ClaimFriendsAndFamilyReferralRequest {
  fnfEmailPrefix: string
  referralName: string
}

interface ApproveFriendsAndFamilyReferralRequest {
  referralEmail: string
  verificationToken: string
}

interface DeleteFriendsAndFamilyReferralRequest {
  items: Array<{
    fnfReferralId: string
  }>
}

export function createFriendsAndFamilyReferralLink(
  payload: CreateFriendsAndFamilyReferralLinkRequest,
): Promise<FriendsAndFamilyReferralLink> {
  return request
    .post<App.ApiResponse<FriendsAndFamilyReferralLink>, CreateFriendsAndFamilyReferralLinkRequest>(
      '/api/flights-charter/v1/fnf-referral-links',
      payload,
      { credentials: 'include', excludeBrand: true },
    )
    .then(response => response.result)
}

export function getFriendsAndFamilyReferrals(
  params: GetFriendsAndFamilyReferralsParams = {},
): Promise<Array<FriendsAndFamilyReferral>> {
  const searchParams = new URLSearchParams()
  if (params.fnfEmail) {
    searchParams.set('fnfEmail', params.fnfEmail)
  }
  searchParams.set('limit', String(params.limit ?? 100))
  searchParams.set('offset', String(params.offset ?? 0))

  return request
    .get<App.ApiResponse<Array<FriendsAndFamilyReferral>>>(
      `/api/flights-charter/v1/fnf-referrals?${searchParams.toString()}`,
      { credentials: 'include', excludeBrand: true },
    )
    .then(response => response.result)
}

export function claimFriendsAndFamilyReferral(
  payload: ClaimFriendsAndFamilyReferralRequest,
): Promise<void> {
  return request
    .post<App.ApiResponse<unknown>, ClaimFriendsAndFamilyReferralRequest>(
      '/api/flights-charter/v1/fnf-referrals/claim',
      payload,
      { credentials: 'include', excludeBrand: true },
    )
    .then(() => undefined)
}

export function deleteFriendsAndFamilyReferral(fnfReferralId: string): Promise<void> {
  return request
    .delete<App.ApiResponse<{ deletedCount: number }>>(
      '/api/flights-charter/v1/fnf-referrals',
      {
        credentials: 'include',
        excludeBrand: true,
        body: {
          items: [{ fnfReferralId }],
        } satisfies DeleteFriendsAndFamilyReferralRequest,
      },
    )
    .then(() => undefined)
}

export function approveFriendsAndFamilyReferral(
  payload: ApproveFriendsAndFamilyReferralRequest,
): Promise<void> {
  return request
    .post<App.ApiResponse<unknown>, ApproveFriendsAndFamilyReferralRequest>(
      '/api/flights-charter/v1/fnf-referrals/approve',
      payload,
      { credentials: 'include', excludeBrand: true },
    )
    .then(() => undefined)
}
